import React from 'react';
import separateLastWord from '../../../utils/utils/separateLastWord';
import styles from './LastStrongWorldText.styles';

/**
 * @param content - text data (required)
 * @param styleProps - used as styles properties which component can have
 * @returns {JSX.Element}
 * @constructor
 */

const LastStrongWorldText = ({ content, ...styleProps }) => {
  const [subtitleBeginningPart, subtitleLastWord] = separateLastWord(content);

  return (
    <div css={styles(styleProps)}>
      <div className="text">
        <p className="text__start-part">{subtitleBeginningPart}</p>
        <span className="text__last-word">{subtitleLastWord}</span>
        <p className="text__all-text--mobile">{content}</p>
      </div>
    </div>
  );
};

export default LastStrongWorldText;
